/**
 * "Did the visitor ask to scroll?" — the one rule, shared by everything that
 * hands the scroll position back on the visitor's first input.
 *
 * EGDE-719 (r3 follow-up): keyboards need the same correction `touchstart` did.
 * Any key at all used to count as taking over, so opening /#FaqAnchor and then
 * pressing Escape, hitting Enter on a link, or typing a word into the header
 * search abandoned the anchor for good — measured, stranded between 51px and
 * 343px with the target past 3500. Only the keys that actually move a page
 * count, and only when they are not being typed into a field, where every key
 * means text rather than travel.
 */
const SCROLL_KEYS = new Set([
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "PageUp",
  "PageDown",
  "Home",
  "End",
  " ",
  "Spacebar",
])

/** True when the keystroke is one that scrolls the document itself. */
export function isScrollIntentKey(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement | null
  const tag = target?.tagName
  if (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    target?.isContentEditable
  ) {
    return false
  }
  return SCROLL_KEYS.has(event.key)
}
